import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../lib/cn.js';
function Bar({ className, style }) {
    return (_jsx("div", { "aria-hidden": "true", style: style, className: cn('animate-pulse rounded-sm bg-neutral-200 motion-reduce:animate-none', className) }));
}
export function Skeleton({ shape = 'block', className, count = 1 }) {
    if (shape === 'block')
        return _jsx(Bar, { className: cn('h-4 w-full', className) });
    if (shape === 'chart') {
        return (_jsx("div", { className: cn('flex h-48 items-end gap-2 rounded-md bg-surface-base p-4', className), children: [40, 70, 55, 90, 65, 80, 50].map((h, i) => (_jsx(Bar, { className: "w-full", style: { height: `${h}%` } }, i))) }));
    }
    const rows = Array.from({ length: count }, (_, i) => i);
    if (shape === 'list-row') {
        return (_jsx("div", { className: cn('space-y-3', className), children: rows.map((i) => (_jsxs("div", { className: "flex items-center gap-3", children: [_jsx(Bar, { className: "h-10 w-10 rounded-full" }), _jsxs("div", { className: "flex-1 space-y-2", children: [_jsx(Bar, { className: "h-3 w-2/3" }), _jsx(Bar, { className: "h-3 w-1/3" })] })] }, i))) }));
    }
    // table-row
    return (_jsx("div", { className: cn('space-y-2', className), children: rows.map((i) => (_jsx(Bar, { className: "h-10 w-full" }, i))) }));
}
//# sourceMappingURL=Skeleton.js.map